<div infiniteScroll 
[infiniteScrollDistance]="numbers.TWO"
[infiniteScrollThrottle]="numbers.FIFTY" [infiniteScrollDisabled]="busyGettingData"   (scrolled)="onScrollDown()" [scrollWindow]="true">
    <div *ngFor="let feedList of postDataByFilter; let index=index" class="mb-3">
        <ng-container *ngIf="feedList?.product_type === productType?.FEED">
            <app-feed-card (deleteFeedIdx)="deleteFeedIdx($event)" [callingfrom]="callingFrom"
                [feedObj]="feedList?.products[0]"
                [ptoductType]="productType?.COMMUNITY" [isCommunityAdmin]="isCommunityAdmin" [feedIdx]="index"
                [textHeighlight]="mls.languageText.community.key175" (emitDeleteCommunityFeed)="deleteCommunityFeed($event)" [communityId]="communityId">
            </app-feed-card>
        </ng-container>

        <!--@@ START WEBINAR @@-->
        <ng-container *ngIf="feedList?.product_type === productType?.WEBINAR">
            <div class="bg-white mb-3 container-shadow">
                <div class="py-2 px-3 secondary-paragraph">
                    <p class="color-grey-700">
                        <img src="assets/themes/icons/gr/webinar.svg" class="mr-2 webinar-icon" alt="webinar icon" />
                        <span *ngIf="feedList.text_highlight"  class="color-grey-700">{{feedList.text_highlight}}</span>
                        <span  *ngIf="!feedList.text_highlight"  class="color-grey-700">{{mls.languageText.community.key176}}</span>
                    </p>
                </div>
                <div class="py-2 px-3 separator-line ">
                    <div *ngFor="let data of feedList.products;">
                        <app-webinar-card [callingfrom]="callingFrom" [docCardObj]='data' [docTalkSection]=''
                            [listLength]='numbers.ONE'>
                        </app-webinar-card>
                    </div>
                </div>
            </div>
        </ng-container>
        <!--@@ END WEBINAR @@-->

        <!--@@ START JOURNAL POST @@-->
        <ng-container *ngIf="feedList?.product_type == productType?.ARTICLE ">
            <div [id]="feedList?.text_highlight+ '-' +feedList?.products[0]?.product_type_id "
                class="mb-3 container-shadow">
                <div class="px-3 py-2 top-border-radius separator-line-btm" [ngClass]="{'d-flex justify-content-between':
                    feedList.products[0]?.editor_choice_data.is_ec_product === numbers.ONE}" [style.background-image]="feedList.products[0]?.editor_choice_data.is_ec_product === numbers.ONE &&
                    feedList.products[0]?.editor_choice_data.headers?.color | gradient: gradientDirection.BOTTOM">
                    <p class="secondary-paragraph-bold" [ngClass]="{
                        'ellipsis': feedList.products[0]?.editor_choice_data.is_ec_product === numbers.ONE}">
                        <img src="assets/themes/icons/gr/clinical-case.svg" class="mr-2" width="25px" />
                        <span *ngIf="feedList.text_highlight" class="color-grey-700">{{feedList.text_highlight}}</span>
                        <span *ngIf="!feedList.text_highlight"  class="color-grey-700">{{mls.languageText.community.key177}}</span>
                    </p>
                    <ng-container *ngIf="feedList.products[0]?.editor_choice_data.is_ec_product === numbers.ONE">
                        <span class="mr-0 ec-badge d-flex align-items-center">
                            <img loading="lazy" class="ec-badge-icon"
                                [src]='feedList.products[0].editor_choice_data.headers?.images.icon'
                                alt="ec badge icon" />
                            <span class="ec-text ec-text-overflow secondary-paragraph"
                                [title]="feedList.products[0].editor_choice_data.headers?.highlight_text">
                                <span
                                    class="color-grey-700">{{feedList.products[0].editor_choice_data.headers?.highlight_text}}</span>
                            </span>
                        </span>
                    </ng-container>
                </div>
                <div class="p-3">
                    <div *ngFor="let data of feedList.products;">
                        <app-clinical-resource-card appear [appearIds]="getAppearedIds(data)"
                            [callingfrom]="callingfrom" [clinicalObj]="data" [idx]="index"
                            (feedSpecialty)="feedListFilteredBySpecialty($event)"
                            (appearedCards)="onCardAppear($event)">
                        </app-clinical-resource-card>
                    </div>
                </div>
            </div>
        </ng-container>
        <!--@@ END JOURNAL POST @@-->

        <!-- START EVENT POST-->
        <!-- <div *ngIf="feedList.product_type == productType?.EVENT && feedList?.mode_of_product == 'offline'">
            <div [id]="feedList?.text_highlight+ '-'+'Card'" class="mb-3 container-shadow">
                <div class="px-3 py-2">
                    <p class="secondary-paragraph-bold">
                        <img src="assets/themes/icons/gr/offline-event.svg" class="mr-2" width="25px" /><span
                            class="color-grey-700">{{feedList.text_highlight}}</span>
                    </p>
                </div>
                <div class="separator-line"></div>
                <div class="p-3">
                    <ng-container *ngFor="let data of feedList.products;">
                        <app-web-events-card appear [appearIds]="getAppearedIds(data)"
                            [eventTracker]='{"category":mls.googleEventText.grandround.category,"action":mls.googleEventText.grandround.key8,"product_type":"7", "product_id":""}'
                            [eventListing]="data" (appearedCards)="onCardAppear($event)">
                        </app-web-events-card>
                    </ng-container>
                </div>
            </div>
        </div> -->
        <!-- END EVENT POST -->


        <!--@@ START CME POST @@-->
        <ng-container *ngIf="feedList.product_type == productType?.CME ">
            <div [id]="feedList?.text_highlight+ '-'+'Card'" class="mb-3 container-shadow bg-white">
                <div class="px-3 py-2">
                    <p class="secondary-paragraph-bold">
                        <img src="assets/themes/icons/gr/cme.svg" class="mr-2" width="25px" />
                        <span *ngIf="feedList.text_highlight" class="color-grey-700">{{feedList.text_highlight}}</span>
                        <span *ngIf="!feedList.text_highlight"  class="color-grey-700">{{mls.languageText.community.key178}}</span>
                    </p>
                </div>
                <div class="separator-line"></div>
                <ng-container *ngFor="let data of feedList.products;">
                    <app-web-cme-card appear [appearIds]="getAppearedIds(data)" [callingfrom]="callingfrom"
                        [cmeObj]="data" (feedSpecialty)="feedListFilteredBySpecialty($event)"
                        (appearedCards)="onCardAppear($event)">
                    </app-web-cme-card>
                </ng-container>
            </div>
        </ng-container>
        <!--@@ END CME POST @@-->

        <!--@@ START DOCTALK @@-->
        <div *ngIf="feedList.product_type == productType?.DOCTALKS ">
            <div [id]="feedList?.text_highlight+ '-'+'Card'" class="mb-3 container-shadow bg-white">
                <div class="px-3 py-2 secondary-paragraph-bold separator-line-btm">
                    <p class="color-grey-700">
                        <img src="assets/themes/icons/gr/doctalks.svg" class="mr-2" width="25px" />
                        <span *ngIf="feedList.text_highlight" class="color-grey-700">{{feedList.text_highlight}}</span>
                        <span *ngIf="!feedList.text_highlight"  class="color-grey-700">{{mls.languageText.community.key179}}</span>
                    </p>
                </div>
                <div class="p-3" *ngFor="let data of feedList.products;">
                    <app-web-doctalk-card appear [appearIds]="getAppearedIds(data)" [callingfrom]="'GRAND_ROUND'"
                        [docCardObj]='data' [docTalkSection]='"features_videos"' [listLength]=2
                        (appearedCards)="onCardAppear($event)">
                    </app-web-doctalk-card>
                </div>
            </div>
        </div>
        <!--@@ END DOCTALK @@-->

        <!--@@ START SURVEY @@-->
        <div *ngIf="feedList.product_type == productType?.SURVEY ">
            <div class="mb-3 container-shadow bg-white">
                <div class="px-3  py-2">
                    <p class="secondary-paragraph-bold">
                        <img src="assets/themes/icons/gr/surveys.svg" class="mr-2" width="25px" />
                        <span *ngIf="feedList.text_highlight" class="color-grey-700">{{feedList.text_highlight}}</span>
                        <span *ngIf="!feedList.text_highlight" class="color-grey-700">{{mls.languageText.community.key180}}</span>
                    </p>
                </div>
                <div class="separator-line"></div>
                <div class="p-3">
                    <ng-container *ngFor="let data of feedList.products;">{{fileSignedUrls}}
                        <app-survey-card [productType]="productType?.SURVEY" [activeTab]="''" [surveyData]="data"
                            [fileSignedUrls]="fileSignedUrls" [isPublicSource]="''"
                            (emitSwitchTab)="changeSurveyType(surveyTabType.ALL)">
                      </app-survey-card>
                    </ng-container>
                </div>
            </div>
        </div>
        <!--@@ END SURVEY @@-->

        <!--Editor choice card invoke start-->
        <div *ngIf="feedList.product_type === productType?.EDITORS_CHOICE">
            <app-editor-choice-card appear [appearIds]="getAppearedIds(feedList)" [editorChoiceCard]="feedList"
                [callingfrom]="ecScreenName" [ecIdx]="index" (feedSpecialty)="feedListFilteredBySpecialty($event)"
                (appearedCards)="onCardAppear($event)" (feedSpecialtyInnerCard)="innerCardSelectedSpecialty($event)">
            </app-editor-choice-card>
        </div>
        <!--Editor choice card invoke end-->

    </div>
</div>
<div class='text-center'>
    <img *ngIf="finished" class="text-center" src="assets/themes/images/img-video-loader.gif" width="40"
        id="loadmore_post" alt="loader">
</div>
<div *ngIf="postDataByFilter?.length === numberZero && postDataLoader === true" class='text-center p-3'>
    <img class="no-data-image mb-3" src="assets/themes/images/no-posts.svg" alt="no data" /><br>
    <span><b>{{mls.languageText.community.key62}}</b></span>
</div>